export const ORDERS_ROUTES = {
  ROOT: "orders",
  DETAIL: ":orderId",
};
